import { render, staticRenderFns } from "./TableDetailImports.vue?vue&type=template&id=2e73b866&scoped=true&"
import script from "./TableDetailImports.vue?vue&type=script&lang=js&"
export * from "./TableDetailImports.vue?vue&type=script&lang=js&"
import style0 from "./TableDetailImports.vue?vue&type=style&index=0&id=2e73b866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e73b866",
  null
  
)

export default component.exports